// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".survey-list-wrapper {\n  position: relative;\n}\n.survey-list-wrapper--empty-text {\n  font-weight: 300;\n  font-size: 12px;\n}\n.survey-list-wrapper--add-survey {\n  position: absolute;\n  top: 1rem;\n  right: 0;\n}\n.survey-list {\n  height: calc(100% - 80px);\n}", ""]);
// Exports
module.exports = exports;
